import {
  formatDate,
  cdnFn
} from '../common/Fn';
export { parseTime, formatTime } from 'src/utils'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

export function date(value, fmt) {
  let date =  new Date(value * 1000);
  if (isNaN(date.getDate())) {
    date = new Date(value);
  }
  return formatDate(date, fmt);
}

export function gender(value) {
  return {
    0: '女',
    1: '男',
    'male':     '男',
    'female':   '女',
    'unknown': '未知'
  }[value];
}
export function courseType(value) {
  return {
    'required_course':     '专业必修课',
    'common_learnings':   '公共必修课',
    'elective_courses': '选修课'
  }[value];
}

export function atSchool(value) {
  return {
    1: '在校',
    0: '离校',
    'unknown': '未知'
  }[value];
}

export function semester(value) {
  return {
   1: '大一上学期',
   2: '大一下学期',
   3: '大二上学期',
   4: '大二下学期',
   5: '大三上学期',
   6: '大三下学期',
   7: '大四上学期',
   8: '大四下学期',
   9: '大五上学期',
   10: '大五下学期',
   11: '大六上学期',
   12: '大六下学期'
  }[value];
}

export function classType(value) {
  return {
    'natural': '行政班',
    'arranging': '排课班',
    'unknown': '未知'
  }[value];
}

export const cdn = cdnFn;



// WEBPACK FOOTER //
// ./src/filters/index.js